<template>
  <v-navigation-drawer v-model="drawer" height="100vh" app>
    <v-list-item
      class="primary px-0"
      dark
      :style="{
        height: `${$vuetify.application.top}px`,
        maxHeight: '64px'
      }"
    >
      <div style="width: 100%; height: 100%" class="d-flex align-center justify-center">
        <strong>AR Auditor</strong>
      </div>
    </v-list-item>
    <v-divider />

    <v-list dense nav>
      <v-list-group
        v-show="itensCadastro.length > 0"
        prepend-icon="mdi-calendar-month"
        no-action
        color="primary"
      >
        <template #activator>
          <v-list-item-content>
            <v-list-item-title>Cadastros</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item v-for="item in itensCadastro" :key="item.title" :to="item.route" link>
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-list-group v-show="itensUsuario.length > 0" prepend-icon="mdi-account-cog" no-action>
        <template #activator>
          <v-list-item-content>
            <v-list-item-title>Usuários</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item v-for="item in itensUsuario" :key="item.title" :to="item.route" link>
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-list-group
        v-show="itensAuditagem.length > 0"
        prepend-icon="mdi-compare-horizontal"
        no-action
      >
        <template #activator>
          <v-list-item-content>
            <v-list-item-title>Auditagem</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item v-for="item in itensAuditagem" :key="item.title" :to="item.route" link>
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <v-list-item
        v-for="item in itensSemMenu"
        :key="item.title"
        :to="item.route"
        link
        color="primary"
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <template #append>
      <v-divider />
      <v-list-item color="primary" @click="logOut">
        <v-list-item-icon>
          <v-icon>mdi-logout</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Sair</v-list-item-title>
      </v-list-item>
    </template>
  </v-navigation-drawer>
</template>

<script>
import store from '@/store'

export default {
  data: () => ({
    name: 'ApplicationSideBar',
    color: 'primary',
    itensSemMenu: [],
    itensCadastro: [],
    itensUsuario: [],
    itensAuditagem: []
  }),

  computed: {
    drawer: {
      get() {
        return store.getters.getDrawer
      },
      set() {}
    }
  },

  created() {
    this.buscaRotinasPermitidas()
  },

  methods: {
    buscaRotinasPermitidas() {
      let menuCadastro = [
        {
          title: 'Fornecedor',
          icon: 'mdi-clipboard-account',
          route: { name: 'TelaDeFornecedor' }
        },
        {
          title: 'Empresa',
          icon: 'mdi-domain',
          route: { name: 'TelaDeEmpresa' }
        },
        {
          title: 'Lei',
          icon: 'mdi-book',
          route: { name: 'TelaDeLei' }
        },
        {
          title: 'CFOP',
          icon: 'mdi-book',
          route: { name: 'TelaDeCFOP' }
        },
        {
          title: 'NCM',
          icon: 'mdi-book',
          route: { name: 'TelaDeNCM' }
        },
        {
          title: 'Segmento',
          icon: 'mdi-book',
          route: { name: 'TelaDeSegmento' }
        },
        {
          title: 'CEST',
          icon: 'mdi-book',
          route: { name: 'TelaDeCEST' }
        },
        {
          title: 'CST',
          icon: 'mdi-book',
          route: { name: 'TelaDeCST' }
        },
        {
          title: 'NESH',
          icon: 'mdi-book',
          route: { name: 'TelaDeNESH' }
        },
        {
          title: 'Natureza',
          icon: 'mdi-book',
          route: { name: 'TelaDeNatureza' }
        },
        {
          title: 'ICMS',
          icon: 'mdi-book',
          route: { name: 'TelaDeICMS' }
        },
        {
          title: 'PISCOFINS',
          icon: 'mdi-book',
          route: { name: 'TelaDePISCOFINS' }
        },
        {
          title: 'Itens VO',
          icon: 'mdi-book',
          route: { name: 'TelaDeItensVO' }
        },
        {
          title: 'IPI',
          icon: 'mdi-book',
          route: { name: 'TelaDeIPI' }
        }
      ]

      let menuUsuario = [
        {
          title: 'Usuários',
          icon: 'mdi-account',
          route: { name: 'TelaDeUsuarios' }
        },
        {
          title: 'Perfis',
          icon: 'mdi-account-multiple',
          route: { name: 'TelaDePerfis' }
        },
        {
          title: 'Permissões',
          icon: 'mdi-lock-open',
          route: { name: 'TelaDePermissoes' }
        }
      ]

      let menuAuditagem = [
        {
          title: 'Atualizações',
          icon: 'mdi-lock-open',
          route: { name: 'TelaDeAtualizacoes' }
        },
        /*{
          title: 'Entradas',
          icon: 'mdi-login',
          route: { name: 'TelaDeEntradas' }
        },
        {
          title: 'Saídas',
          icon: 'mdi-logout',
          route: { name: 'TelaDeEntradas' }
        },*/
        {
          title: 'Itens do Cliente',
          icon: 'mdi-tag',
          route: { name: 'TelaDeItensCliente' }
        },
        {
          title: 'Vinculador',
          icon: 'mdi-vector-link',
          route: { name: 'TelaDeVinculoItens' }
        }
      ]

      this.itensSemMenu = [
        {
          title: 'NFe',
          icon: 'mdi-file-document-outline',
          route: { name: 'TelaDeNFes' }
        },
        {
          title: 'Tributação',
          icon: 'mdi-calculator-variant-outline',
          route: { name: 'TelaDeTributacao' }
        }
      ]

      const rotinasPermitidas = store.getters.getRotinasPermitidasDoUsuario

      this.itensCadastro = menuCadastro.filter((item) => {
        return rotinasPermitidas.includes(item.route.name)
      })

      this.itensUsuario = menuUsuario.filter((item) => {
        return rotinasPermitidas.includes(item.route.name)
      })

      this.itensAuditagem = menuAuditagem
    },
    logOut() {
      store.dispatch('logOut')
    }
  }
}
</script>
